export class BotPromptSuggestion {
  static SUBCOL = 'suggestions'; // soribots/suggestions
  public updated?: Date;
  public isActive: boolean = true;

  constructor(
    public id: string,
    public botId: string,
    public prompt: string,
    public response: string | null
  ) {
  }
};